import React, { PureComponent } from 'react';

import './pdf-viewer.scss';

import { bool, string } from 'prop-types';

import { PDFViewerAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';

import { Loader } from '..';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: PDFViewerAPI })
class PDFViewer extends PureComponent {

  static propTypes = {
    uuid: string,
    src: string,
    visible: bool,
    loading: bool,
  };

  static defaultProps = {
    visible: true,
  };

  render() {
    const { src, loading, visible } = this.props;

    const styles = {
      width: '100%',
      height: 'auto',
    };

    if (!visible) {
      return null;
    }

    return (
      <div className="c-pdf-viewer">
        {loading
          ? <Loader size={64} className="c-pdf-viewer__loader"/>
          : <object data={src} type="application/pdf" style={styles}/>}
      </div>
    );
  }
}

export default PDFViewer;
